// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"map-search-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 5.08966C12 7.5 9 9.46667 9 9.46667C9 9.46667 6 7.5 6 5.08966C6 3.38329 7.23637 2 9 2C10.75 2 12 3.38329 12 5.08966Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 16.25C21 18.3211 19.3211 20 17.25 20C15.1789 20 13.5 18.3211 13.5 16.25C13.5 14.1789 15.1789 12.5 17.25 12.5C19.3211 12.5 21 14.1789 21 16.25Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 5.2002H21V9.50019M6 5.2002H3V19.0002H10M9 14.5002L6 12.6002L3.375 14.0002M12 5.08965C12 7.5 9 9.46667 9 9.46667C9 9.46667 6 7.5 6 5.08965C6 3.38329 7.23638 2 9 2C10.75 2 12 3.38329 12 5.08965Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19.9036 18.8997L21.5 20.5M21 16.25C21 18.3211 19.3211 20 17.25 20C15.1789 20 13.5 18.3211 13.5 16.25C13.5 14.1789 15.1789 12.5 17.25 12.5C19.3211 12.5 21 14.1789 21 16.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MapSearch1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-search-1',
    ref,
    icon: element,
  },
));

MapSearch1Icon.displayName = 'MapSearch1Icon';

export default MapSearch1Icon;
